// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27300%27 height=%27300%27 viewBox=%270 0 300 300%27%3E%3Cdefs%3E%3Cg id=%27card%27%3E%3Crect x=%271%27 y=%274%27 width=%2722%27 height=%2716%27 rx=%272.5%27/%3E%3Cpath d=%27M1 10h22M5 15h5%27/%3E%3C/g%3E%3Cg id=%27box%27%3E%3Cpath d=%27M12 2l9 5v10l-9 5-9-5V7z%27/%3E%3Cpath d=%27M3 7l9 5 9-5M12 12v10%27/%3E%3C/g%3E%3Cg id=%27pin%27%3E%3Cpath d=%27M12 22s7-7.5 7-12a7 7 0 1 0-14 0c0 4.5 7 12 7 12z%27/%3E%3Ccircle cx=%2712%27 cy=%2710%27 r=%272.5%27/%3E%3C/g%3E%3Cg id=%27sign%27%3E%3Cpath d=%27M12 3v18%27/%3E%3Crect x=%274%27 y=%276%27 width=%2716%27 height=%277%27 rx=%271.5%27/%3E%3C/g%3E%3Cg id=%27doc%27%3E%3Crect x=%275%27 y=%272%27 width=%2714%27 height=%2720%27 rx=%272%27/%3E%3Cpath d=%27M9 7h6M9 11h6M9 15h4%27/%3E%3C/g%3E%3Cg id=%27pay%27%3E%3Cpath d=%27M12 1v22%27/%3E%3Cpath d=%27M17.5 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6%27/%3E%3C/g%3E%3Cg id=%27truck%27%3E%3Cpath d=%27M1 6h13v11H1z%27/%3E%3Cpath d=%27M14 9h4l3 3v5h-7z%27/%3E%3Ccircle cx=%275.5%27 cy=%2719%27 r=%272%27/%3E%3Ccircle cx=%2718.5%27 cy=%2719%27 r=%272%27/%3E%3C/g%3E%3Cg id=%27ok%27%3E%3Ccircle cx=%2712%27 cy=%2712%27 r=%279%27/%3E%3Cpath d=%27M8 12.5l2.8 2.8L16 9.8%27/%3E%3C/g%3E%3Cg id=%27tag%27%3E%3Cpath d=%27M20.5 12.5l-8 8-9.5-9.5V3h8z%27/%3E%3Ccircle cx=%277.5%27 cy=%277.5%27 r=%271.6%27/%3E%3C/g%3E%3C/defs%3E%3Cg fill=%27none%27 stroke=%27%232d63eb%27 stroke-width=%271.6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-opacity=%270.14%27%3E%3Cuse href=%27%23card%27 transform=%27translate%2814,18%29 rotate%28-16%29 scale%281.05%29%27/%3E%3Cuse href=%27%23box%27 transform=%27translate%28101,6%29 rotate%2813%29 scale%280.9%29%27/%3E%3Cuse href=%27%23pin%27 transform=%27translate%28182,30%29 rotate%28-7%29 scale%281%29%27/%3E%3Cuse href=%27%23pay%27 transform=%27translate%28248,8%29 rotate%2819%29 scale%280.86%29%27/%3E%3Cuse href=%27%23doc%27 transform=%27translate%2851,76%29 rotate%288%29 scale%280.95%29%27/%3E%3Cuse href=%27%23truck%27 transform=%27translate%28136,62%29 rotate%28-21%29 scale%281.1%29%27/%3E%3Cuse href=%27%23sign%27 transform=%27translate%28228,90%29 rotate%286%29 scale%280.92%29%27/%3E%3Cuse href=%27%23ok%27 transform=%27translate%288,129%29 rotate%2823%29 scale%280.86%29%27/%3E%3Cuse href=%27%23tag%27 transform=%27translate%2890,138%29 rotate%28-9%29 scale%281.05%29%27/%3E%3Cuse href=%27%23card%27 transform=%27translate%28172,152%29 rotate%2815%29 scale%280.9%29%27/%3E%3Cuse href=%27%23box%27 transform=%27translate%28252,160%29 rotate%28-17%29 scale%280.98%29%27/%3E%3Cuse href=%27%23pay%27 transform=%27translate%2830,196%29 rotate%28-11%29 scale%281%29%27/%3E%3Cuse href=%27%23pin%27 transform=%27translate%28115,214%29 rotate%2817%29 scale%280.86%29%27/%3E%3Cuse href=%27%23doc%27 transform=%27translate%28196,225%29 rotate%28-23%29 scale%280.95%29%27/%3E%3Cuse href=%27%23ok%27 transform=%27translate%28256,244%29 rotate%289%29 scale%280.9%29%27/%3E%3Cuse href=%27%23sign%27 transform=%27translate%2860,253%29 rotate%2821%29 scale%280.92%29%27/%3E%3Cuse href=%27%23truck%27 transform=%27translate%28150,254%29 rotate%28-13%29 scale%280.86%29%27/%3E%3Cuse href=%27%23tag%27 transform=%27translate%28225,172%29 rotate%2828%29 scale%280.8%29%27/%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Agent Chat Agent — self-contained styles (easy to remove with the component) */

.aca-root {
  --aca-blue: #2d63eb;
  --aca-orange: #f58b01;
  --aca-accent: #2d63eb;
  --aca-accent-2: #4b7cf0;
  --aca-ink: #0f172a;
  --aca-muted: #64748b;
  --aca-panel: #ffffff;
  --aca-soft: #f5f7fb;
  --aca-border: #e2e8f0;
  --aca-user: #2d63eb;
  --aca-bot: #ffffff;
  --aca-shadow: 0 18px 50px rgba(45, 99, 235, 0.2);
  --aca-radius: 18px;
  position: fixed;
  right: max(30px, env(safe-area-inset-right));
  bottom: max(30px, env(safe-area-inset-bottom));
  z-index: 1080;
  font-family: "Segoe UI", system-ui, -apple-system, sans-serif;
  pointer-events: none;
}

.aca-root * {
  box-sizing: border-box;
}

.aca-fab {
  pointer-events: auto;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(145deg, var(--aca-blue), #1f4fd4);
  box-shadow: 0 10px 28px rgba(45, 99, 235, 0.45);
  position: relative;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.aca-fab:hover {
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 14px 32px rgba(45, 99, 235, 0.55);
}

.aca-fab:active {
  transform: scale(0.96);
}

.aca-fab::before,
.aca-fab::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid rgba(245, 139, 1, 0.55);
  animation: aca-pulse 2.4s ease-out infinite;
  pointer-events: none;
}

.aca-fab::after {
  animation-delay: 1.1s;
}

@keyframes aca-pulse {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  100% {
    transform: scale(1.7);
    opacity: 0;
  }
}

.aca-panel {
  pointer-events: auto;
  position: absolute;
  right: 0;
  bottom: 0;
  width: min(400px, calc(100vw - 24px));
  height: min(640px, calc(100dvh - 32px));
  max-height: calc(100dvh - 24px);
  display: flex;
  flex-direction: column;
  background: var(--aca-panel);
  border-radius: var(--aca-radius);
  border: 1px solid var(--aca-border);
  box-shadow: var(--aca-shadow);
  overflow: hidden;
  transform-origin: bottom right;
  animation: aca-panel-in 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes aca-panel-in {
  from {
    opacity: 0;
    transform: translateY(18px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.aca-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 14px 14px 16px;
  background: linear-gradient(120deg, #1f4fd4 0%, #2d63eb 55%, #4b7cf0 100%);
  color: #fff;
}

.aca-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.aca-avatar {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.35);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #ffffff;
}

.aca-root .aca-avatar-icon {
  width: 22px !important;
  height: 22px !important;
  display: block;
  color: #ffffff;
}

.aca-online-dot {
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #2d63eb;
}

.aca-root .aca-fab-icon {
  width: 30px !important;
  height: 30px !important;
  display: block;
  color: #ffffff;
}

.aca-title-wrap {
  min-width: 0;
}

.aca-root .aca-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #ffffff;
}

.aca-root .aca-subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
}

.aca-root .aca-close {
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 50%;
  border: none;
  background: transparent;
  color: #ffffff;
  opacity: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
  flex-shrink: 0;
}

/* Theme resets can hide/shrink header icons — pin size and color explicitly */
.aca-root .aca-close .aca-close-icon {
  width: 20px !important;
  height: 20px !important;
  display: block;
  fill: none !important;
  stroke: #ffffff !important;
  color: #ffffff;
}

.aca-root .aca-close:hover,
.aca-root .aca-close:focus-visible {
  background: rgba(255, 255, 255, 0.24);
  outline: none;
}

.aca-root .aca-close:hover .aca-close-icon {
  stroke: #ffffff !important;
}

.aca-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 14px;
  /* WhatsApp-style tiled doodle of project icons: cards, orders, signage, payments, address, shipping */
  background-image:
    radial-gradient(circle at top right, rgba(45, 99, 235, 0.08), transparent 42%),
    radial-gradient(circle at bottom left, rgba(245, 139, 1, 0.07), transparent 38%),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: auto, auto, 300px 300px;
  background-repeat: no-repeat, no-repeat, repeat;
  background-color: #f3f6fc;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.aca-welcome {
  text-align: center;
  padding: 28px 12px 8px;
  color: var(--aca-muted);
}

.aca-welcome strong {
  display: block;
  color: var(--aca-ink);
  font-size: 15px;
  margin-bottom: 6px;
}

.aca-msg {
  max-width: 88%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  animation: aca-msg-in 0.22s ease;
}

@keyframes aca-msg-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.aca-msg--user {
  align-self: flex-end;
}

.aca-msg--bot {
  align-self: flex-start;
  max-width: 94%;
}

.aca-body::-webkit-scrollbar {
  width: 6px;
}

.aca-body::-webkit-scrollbar-thumb {
  background: rgba(45, 99, 235, 0.25);
  border-radius: 999px;
}

.aca-body::-webkit-scrollbar-thumb:hover {
  background: rgba(45, 99, 235, 0.45);
}

.aca-bubble {
  padding: 11px 13px;
  border-radius: 16px;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.aca-msg--user .aca-bubble {
  background: linear-gradient(135deg, #2d63eb, #1f4fd4);
  color: #fff;
  border-bottom-right-radius: 5px;
  box-shadow: 0 6px 16px rgba(45, 99, 235, 0.28);
}

.aca-msg--bot .aca-bubble {
  background: var(--aca-bot);
  color: var(--aca-ink);
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-bottom-left-radius: 5px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.07);
}

.aca-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.aca-options-hint {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--aca-blue);
  padding-left: 2px;
}

.aca-option {
  display: flex;
  align-items: center;
  gap: 10px;
  text-align: left;
  border: 1.5px solid #d7e0f5;
  border-left: 4px solid var(--aca-blue);
  background: #fff;
  color: var(--aca-ink);
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.4;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.06);
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease,
    box-shadow 0.15s ease;
}

.aca-option:hover:not(:disabled) {
  border-color: var(--aca-orange);
  border-left-color: var(--aca-orange);
  background: #fff8ef;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(245, 139, 1, 0.22);
}

.aca-option:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.aca-option-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--aca-orange), #ffa733);
  color: #fff;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(245, 139, 1, 0.35);
}

.aca-option-label {
  flex: 1 1;
  min-width: 0;
}

.aca-preview {
  border: 1px solid #d7e0f5;
  border-top: 3px solid var(--aca-orange);
  background: #fff;
  border-radius: 14px;
  padding: 12px;
  font-size: 13px;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
}

.aca-preview h4 {
  margin: 0 0 8px;
  font-size: 13px;
  color: var(--aca-blue);
  font-weight: 700;
}

.aca-preview-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 4px 0;
  color: var(--aca-ink);
}

.aca-preview-row span:last-child {
  font-weight: 600;
  text-align: right;
}

.aca-preview-total {
  margin-top: 6px;
  padding-top: 8px;
  border-top: 1px dashed var(--aca-border);
  font-weight: 700;
}

.aca-report {
  width: 100%;
  overflow: hidden;
  border: 1px solid #d7e0f5;
  border-top: 3px solid var(--aca-blue);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.09);
}

.aca-report-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 12px;
  border-bottom: 1px solid var(--aca-border);
}

.aca-report-heading h4,
.aca-report-heading p {
  margin: 0;
}

.aca-report-heading h4 {
  color: var(--aca-blue);
  font-size: 13px;
  font-weight: 700;
}

.aca-report-heading p {
  margin-top: 3px;
  color: var(--aca-muted);
  font-size: 11px;
}

.aca-report-count {
  flex-shrink: 0;
  padding: 3px 7px;
  border-radius: 999px;
  background: #eef4ff;
  color: var(--aca-blue);
  font-size: 10px;
  font-weight: 700;
}

.aca-report-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 10px 12px;
  background: #f8faff;
  border-bottom: 1px solid var(--aca-border);
}

.aca-report-stat {
  min-width: 0;
}

.aca-report-stat span,
.aca-report-stat strong {
  display: block;
}

.aca-report-stat span {
  color: var(--aca-muted);
  font-size: 10px;
}

.aca-report-stat strong {
  margin-top: 2px;
  color: var(--aca-ink);
  font-size: 13px;
}

.aca-report-table-wrap {
  max-height: 280px;
  overflow: auto;
}

.aca-report-table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  color: var(--aca-ink);
  font-size: 11px;
}

.aca-report-table th,
.aca-report-table td {
  max-width: 180px;
  padding: 8px 10px;
  border-bottom: 1px solid #edf1f7;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.aca-report-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #eef4ff;
  color: #334155;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.aca-report-table tbody tr:last-child td {
  border-bottom: none;
}

.aca-report-empty {
  color: var(--aca-muted);
  text-align: center !important;
}

.aca-report-footer {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 12px;
  border-top: 1px solid var(--aca-border);
  color: var(--aca-muted);
  font-size: 10px;
}

.aca-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.aca-btn {
  border: none;
  border-radius: 10px;
  padding: 9px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.aca-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.aca-btn:not(:disabled):hover {
  transform: translateY(-1px);
}

.aca-btn--primary {
  background: var(--aca-orange);
  color: #fff;
}

.aca-btn--ghost {
  background: #fff;
  color: var(--aca-ink);
  border: 1px solid var(--aca-border);
}

.aca-typing {
  align-self: flex-start;
  display: inline-flex;
  gap: 4px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid var(--aca-border);
  border-radius: 14px;
}

.aca-typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--aca-muted);
  animation: aca-dot 1.1s infinite ease-in-out;
}

.aca-typing span:nth-child(2) {
  animation-delay: 0.15s;
}

.aca-typing span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes aca-dot {
  0%,
  80%,
  100% {
    opacity: 0.35;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-3px);
  }
}

.aca-footer {
  border-top: 1px solid var(--aca-border);
  background: #fff;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
  display: flex;
  gap: 8px;
  align-items: flex-end;
}

/* Border lives on the wrap so the textarea scrollbar cannot clip the right edge */
.aca-input-wrap {
  flex: 1 1;
  min-width: 0;
  border: 1.5px solid var(--aca-border);
  border-radius: 12px;
  background: var(--aca-soft);
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.aca-input-wrap:focus-within {
  border-color: var(--aca-blue);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(45, 99, 235, 0.15);
}

.aca-root .aca-input {
  display: block;
  width: 100%;
  min-height: 42px;
  max-height: 110px;
  resize: none;
  border: none !important;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.35;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
  color: var(--aca-ink);
}

.aca-root .aca-input:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.aca-root .aca-send {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 12px;
  background: var(--aca-orange);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.15s ease;
}

.aca-root .aca-send .aca-send-icon {
  width: 26px !important;
  height: 26px !important;
  color: #fff;
  stroke: #fff;
}

.aca-root .aca-send:hover:not(:disabled),
.aca-root .aca-send:focus-visible:not(:disabled) {
  background: #ffb347;
  color: #fff;
  outline: none;
  transform: translateY(-1px);
}

.aca-root .aca-send:active:not(:disabled) {
  background: #e67e00;
  transform: translateY(0);
}

.aca-root .aca-send:disabled {
  background: #f7c78a;
  color: #fff;
  opacity: 1;
  cursor: not-allowed;
}

.aca-root .aca-send:disabled .aca-send-icon {
  opacity: 0.85;
}

.aca-state-pill {
  align-self: center;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  color: var(--aca-blue);
  background: rgba(255, 255, 255, 0.95);
  border: 1px solid #d7e0f5;
  border-radius: 999px;
  padding: 4px 12px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

@media (max-width: 768px) {
  .aca-root {
    right: 12px;
    bottom: 12px;
  }

  .aca-panel {
    width: calc(100vw - 24px);
    height: min(78dvh, 620px);
    border-radius: 16px;
  }

  .aca-fab {
    width: 56px;
    height: 56px;
  }
}

@media (max-width: 480px) {
  .aca-panel {
    position: fixed;
    inset: auto 0 0 0;
    width: 100vw;
    height: min(88dvh, 100dvh);
    max-height: 100dvh;
    border-radius: 18px 18px 0 0;
    right: 0;
    bottom: 0;
  }

  .aca-root {
    right: 12px;
    bottom: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AgentChatAgent/AgentChatAgent.css"],"names":[],"mappings":"AAAA,iFAAiF;;AAEjF;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;EACf,4CAA4C;EAC5C,8CAA8C;EAC9C,aAAa;EACb,6DAA6D;EAC7D,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,6DAA6D;EAC7D,+CAA+C;EAC/C,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,yCAAyC;EACzC,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,gCAAgC;EAChC,mCAAmC;EACnC,6BAA6B;EAC7B,gBAAgB;EAChB,8BAA8B;EAC9B,4DAA4D;AAC9D;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,4BAA4B;EAC5B,0EAA0E;EAC1E,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,sGAAsG;EACtG;;;2CAG+oF;EAC/oF,wCAAwC;EACxC,+CAA+C;EAC/C,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,0CAA0C;EAC1C,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;EAC7C;yBACuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+DAA+D;EAC/D,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,0CAA0C;AAC5C;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,uCAAuC;EACvC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;;IAGE,aAAa;IACb,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,2DAA2D;EAC3D,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;;AAEA,kFAAkF;AAClF;EACE,SAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;EAC3B,iFAAiF;AACnF;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;EACtB,qCAAqC;EACrC,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;IAClB,4BAA4B;IAC5B,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Agent Chat Agent — self-contained styles (easy to remove with the component) */\n\n.aca-root {\n  --aca-blue: #2d63eb;\n  --aca-orange: #f58b01;\n  --aca-accent: #2d63eb;\n  --aca-accent-2: #4b7cf0;\n  --aca-ink: #0f172a;\n  --aca-muted: #64748b;\n  --aca-panel: #ffffff;\n  --aca-soft: #f5f7fb;\n  --aca-border: #e2e8f0;\n  --aca-user: #2d63eb;\n  --aca-bot: #ffffff;\n  --aca-shadow: 0 18px 50px rgba(45, 99, 235, 0.2);\n  --aca-radius: 18px;\n  position: fixed;\n  right: max(30px, env(safe-area-inset-right));\n  bottom: max(30px, env(safe-area-inset-bottom));\n  z-index: 1080;\n  font-family: \"Segoe UI\", system-ui, -apple-system, sans-serif;\n  pointer-events: none;\n}\n\n.aca-root * {\n  box-sizing: border-box;\n}\n\n.aca-fab {\n  pointer-events: auto;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  background: linear-gradient(145deg, var(--aca-blue), #1f4fd4);\n  box-shadow: 0 10px 28px rgba(45, 99, 235, 0.45);\n  position: relative;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.aca-fab:hover {\n  transform: translateY(-2px) scale(1.04);\n  box-shadow: 0 14px 32px rgba(45, 99, 235, 0.55);\n}\n\n.aca-fab:active {\n  transform: scale(0.96);\n}\n\n.aca-fab::before,\n.aca-fab::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 2px solid rgba(245, 139, 1, 0.55);\n  animation: aca-pulse 2.4s ease-out infinite;\n  pointer-events: none;\n}\n\n.aca-fab::after {\n  animation-delay: 1.1s;\n}\n\n@keyframes aca-pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.7;\n  }\n  100% {\n    transform: scale(1.7);\n    opacity: 0;\n  }\n}\n\n.aca-panel {\n  pointer-events: auto;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: min(400px, calc(100vw - 24px));\n  height: min(640px, calc(100dvh - 32px));\n  max-height: calc(100dvh - 24px);\n  display: flex;\n  flex-direction: column;\n  background: var(--aca-panel);\n  border-radius: var(--aca-radius);\n  border: 1px solid var(--aca-border);\n  box-shadow: var(--aca-shadow);\n  overflow: hidden;\n  transform-origin: bottom right;\n  animation: aca-panel-in 0.28s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n@keyframes aca-panel-in {\n  from {\n    opacity: 0;\n    transform: translateY(18px) scale(0.96);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.aca-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 14px 14px 16px;\n  background: linear-gradient(120deg, #1f4fd4 0%, #2d63eb 55%, #4b7cf0 100%);\n  color: #fff;\n}\n\n.aca-header-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.aca-avatar {\n  position: relative;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #ffffff;\n}\n\n.aca-root .aca-avatar-icon {\n  width: 22px !important;\n  height: 22px !important;\n  display: block;\n  color: #ffffff;\n}\n\n.aca-online-dot {\n  position: absolute;\n  right: -1px;\n  bottom: -1px;\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: #22c55e;\n  border: 2px solid #2d63eb;\n}\n\n.aca-root .aca-fab-icon {\n  width: 30px !important;\n  height: 30px !important;\n  display: block;\n  color: #ffffff;\n}\n\n.aca-title-wrap {\n  min-width: 0;\n}\n\n.aca-root .aca-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #ffffff;\n}\n\n.aca-root .aca-subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.aca-root .aca-close {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border-radius: 50%;\n  border: none;\n  background: transparent;\n  color: #ffffff;\n  opacity: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  flex-shrink: 0;\n}\n\n/* Theme resets can hide/shrink header icons — pin size and color explicitly */\n.aca-root .aca-close .aca-close-icon {\n  width: 20px !important;\n  height: 20px !important;\n  display: block;\n  fill: none !important;\n  stroke: #ffffff !important;\n  color: #ffffff;\n}\n\n.aca-root .aca-close:hover,\n.aca-root .aca-close:focus-visible {\n  background: rgba(255, 255, 255, 0.24);\n  outline: none;\n}\n\n.aca-root .aca-close:hover .aca-close-icon {\n  stroke: #ffffff !important;\n}\n\n.aca-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 14px;\n  /* WhatsApp-style tiled doodle of project icons: cards, orders, signage, payments, address, shipping */\n  background-image:\n    radial-gradient(circle at top right, rgba(45, 99, 235, 0.08), transparent 42%),\n    radial-gradient(circle at bottom left, rgba(245, 139, 1, 0.07), transparent 38%),\n    url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300' viewBox='0 0 300 300'%3E%3Cdefs%3E%3Cg id='card'%3E%3Crect x='1' y='4' width='22' height='16' rx='2.5'/%3E%3Cpath d='M1 10h22M5 15h5'/%3E%3C/g%3E%3Cg id='box'%3E%3Cpath d='M12 2l9 5v10l-9 5-9-5V7z'/%3E%3Cpath d='M3 7l9 5 9-5M12 12v10'/%3E%3C/g%3E%3Cg id='pin'%3E%3Cpath d='M12 22s7-7.5 7-12a7 7 0 1 0-14 0c0 4.5 7 12 7 12z'/%3E%3Ccircle cx='12' cy='10' r='2.5'/%3E%3C/g%3E%3Cg id='sign'%3E%3Cpath d='M12 3v18'/%3E%3Crect x='4' y='6' width='16' height='7' rx='1.5'/%3E%3C/g%3E%3Cg id='doc'%3E%3Crect x='5' y='2' width='14' height='20' rx='2'/%3E%3Cpath d='M9 7h6M9 11h6M9 15h4'/%3E%3C/g%3E%3Cg id='pay'%3E%3Cpath d='M12 1v22'/%3E%3Cpath d='M17.5 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6'/%3E%3C/g%3E%3Cg id='truck'%3E%3Cpath d='M1 6h13v11H1z'/%3E%3Cpath d='M14 9h4l3 3v5h-7z'/%3E%3Ccircle cx='5.5' cy='19' r='2'/%3E%3Ccircle cx='18.5' cy='19' r='2'/%3E%3C/g%3E%3Cg id='ok'%3E%3Ccircle cx='12' cy='12' r='9'/%3E%3Cpath d='M8 12.5l2.8 2.8L16 9.8'/%3E%3C/g%3E%3Cg id='tag'%3E%3Cpath d='M20.5 12.5l-8 8-9.5-9.5V3h8z'/%3E%3Ccircle cx='7.5' cy='7.5' r='1.6'/%3E%3C/g%3E%3C/defs%3E%3Cg fill='none' stroke='%232d63eb' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' stroke-opacity='0.14'%3E%3Cuse href='%23card' transform='translate(14,18) rotate(-16) scale(1.05)'/%3E%3Cuse href='%23box' transform='translate(101,6) rotate(13) scale(0.9)'/%3E%3Cuse href='%23pin' transform='translate(182,30) rotate(-7) scale(1)'/%3E%3Cuse href='%23pay' transform='translate(248,8) rotate(19) scale(0.86)'/%3E%3Cuse href='%23doc' transform='translate(51,76) rotate(8) scale(0.95)'/%3E%3Cuse href='%23truck' transform='translate(136,62) rotate(-21) scale(1.1)'/%3E%3Cuse href='%23sign' transform='translate(228,90) rotate(6) scale(0.92)'/%3E%3Cuse href='%23ok' transform='translate(8,129) rotate(23) scale(0.86)'/%3E%3Cuse href='%23tag' transform='translate(90,138) rotate(-9) scale(1.05)'/%3E%3Cuse href='%23card' transform='translate(172,152) rotate(15) scale(0.9)'/%3E%3Cuse href='%23box' transform='translate(252,160) rotate(-17) scale(0.98)'/%3E%3Cuse href='%23pay' transform='translate(30,196) rotate(-11) scale(1)'/%3E%3Cuse href='%23pin' transform='translate(115,214) rotate(17) scale(0.86)'/%3E%3Cuse href='%23doc' transform='translate(196,225) rotate(-23) scale(0.95)'/%3E%3Cuse href='%23ok' transform='translate(256,244) rotate(9) scale(0.9)'/%3E%3Cuse href='%23sign' transform='translate(60,253) rotate(21) scale(0.92)'/%3E%3Cuse href='%23truck' transform='translate(150,254) rotate(-13) scale(0.86)'/%3E%3Cuse href='%23tag' transform='translate(225,172) rotate(28) scale(0.8)'/%3E%3C/g%3E%3C/svg%3E\");\n  background-size: auto, auto, 300px 300px;\n  background-repeat: no-repeat, no-repeat, repeat;\n  background-color: #f3f6fc;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.aca-welcome {\n  text-align: center;\n  padding: 28px 12px 8px;\n  color: var(--aca-muted);\n}\n\n.aca-welcome strong {\n  display: block;\n  color: var(--aca-ink);\n  font-size: 15px;\n  margin-bottom: 6px;\n}\n\n.aca-msg {\n  max-width: 88%;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  animation: aca-msg-in 0.22s ease;\n}\n\n@keyframes aca-msg-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.aca-msg--user {\n  align-self: flex-end;\n}\n\n.aca-msg--bot {\n  align-self: flex-start;\n  max-width: 94%;\n}\n\n.aca-body::-webkit-scrollbar {\n  width: 6px;\n}\n\n.aca-body::-webkit-scrollbar-thumb {\n  background: rgba(45, 99, 235, 0.25);\n  border-radius: 999px;\n}\n\n.aca-body::-webkit-scrollbar-thumb:hover {\n  background: rgba(45, 99, 235, 0.45);\n}\n\n.aca-bubble {\n  padding: 11px 13px;\n  border-radius: 16px;\n  font-size: 14px;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.aca-msg--user .aca-bubble {\n  background: linear-gradient(135deg, #2d63eb, #1f4fd4);\n  color: #fff;\n  border-bottom-right-radius: 5px;\n  box-shadow: 0 6px 16px rgba(45, 99, 235, 0.28);\n}\n\n.aca-msg--bot .aca-bubble {\n  background: var(--aca-bot);\n  color: var(--aca-ink);\n  border: 1px solid rgba(226, 232, 240, 0.9);\n  border-bottom-left-radius: 5px;\n  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.07);\n}\n\n.aca-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.aca-options-hint {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--aca-blue);\n  padding-left: 2px;\n}\n\n.aca-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-align: left;\n  border: 1.5px solid #d7e0f5;\n  border-left: 4px solid var(--aca-blue);\n  background: #fff;\n  color: var(--aca-ink);\n  border-radius: 12px;\n  padding: 12px 14px;\n  font-size: 13.5px;\n  font-weight: 600;\n  line-height: 1.4;\n  cursor: pointer;\n  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.06);\n  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease,\n    box-shadow 0.15s ease;\n}\n\n.aca-option:hover:not(:disabled) {\n  border-color: var(--aca-orange);\n  border-left-color: var(--aca-orange);\n  background: #fff8ef;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(245, 139, 1, 0.22);\n}\n\n.aca-option:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.aca-option-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--aca-orange), #ffa733);\n  color: #fff;\n  font-weight: 700;\n  font-size: 12px;\n  flex-shrink: 0;\n  box-shadow: 0 2px 6px rgba(245, 139, 1, 0.35);\n}\n\n.aca-option-label {\n  flex: 1;\n  min-width: 0;\n}\n\n.aca-preview {\n  border: 1px solid #d7e0f5;\n  border-top: 3px solid var(--aca-orange);\n  background: #fff;\n  border-radius: 14px;\n  padding: 12px;\n  font-size: 13px;\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);\n}\n\n.aca-preview h4 {\n  margin: 0 0 8px;\n  font-size: 13px;\n  color: var(--aca-blue);\n  font-weight: 700;\n}\n\n.aca-preview-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 4px 0;\n  color: var(--aca-ink);\n}\n\n.aca-preview-row span:last-child {\n  font-weight: 600;\n  text-align: right;\n}\n\n.aca-preview-total {\n  margin-top: 6px;\n  padding-top: 8px;\n  border-top: 1px dashed var(--aca-border);\n  font-weight: 700;\n}\n\n.aca-report {\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid #d7e0f5;\n  border-top: 3px solid var(--aca-blue);\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.09);\n}\n\n.aca-report-heading {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px;\n  border-bottom: 1px solid var(--aca-border);\n}\n\n.aca-report-heading h4,\n.aca-report-heading p {\n  margin: 0;\n}\n\n.aca-report-heading h4 {\n  color: var(--aca-blue);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.aca-report-heading p {\n  margin-top: 3px;\n  color: var(--aca-muted);\n  font-size: 11px;\n}\n\n.aca-report-count {\n  flex-shrink: 0;\n  padding: 3px 7px;\n  border-radius: 999px;\n  background: #eef4ff;\n  color: var(--aca-blue);\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.aca-report-summary {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n  padding: 10px 12px;\n  background: #f8faff;\n  border-bottom: 1px solid var(--aca-border);\n}\n\n.aca-report-stat {\n  min-width: 0;\n}\n\n.aca-report-stat span,\n.aca-report-stat strong {\n  display: block;\n}\n\n.aca-report-stat span {\n  color: var(--aca-muted);\n  font-size: 10px;\n}\n\n.aca-report-stat strong {\n  margin-top: 2px;\n  color: var(--aca-ink);\n  font-size: 13px;\n}\n\n.aca-report-table-wrap {\n  max-height: 280px;\n  overflow: auto;\n}\n\n.aca-report-table {\n  width: max-content;\n  min-width: 100%;\n  border-collapse: collapse;\n  color: var(--aca-ink);\n  font-size: 11px;\n}\n\n.aca-report-table th,\n.aca-report-table td {\n  max-width: 180px;\n  padding: 8px 10px;\n  border-bottom: 1px solid #edf1f7;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.aca-report-table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #eef4ff;\n  color: #334155;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.aca-report-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.aca-report-empty {\n  color: var(--aca-muted);\n  text-align: center !important;\n}\n\n.aca-report-footer {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 7px 12px;\n  border-top: 1px solid var(--aca-border);\n  color: var(--aca-muted);\n  font-size: 10px;\n}\n\n.aca-actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.aca-btn {\n  border: none;\n  border-radius: 10px;\n  padding: 9px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.15s ease, opacity 0.15s ease;\n}\n\n.aca-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.aca-btn:not(:disabled):hover {\n  transform: translateY(-1px);\n}\n\n.aca-btn--primary {\n  background: var(--aca-orange);\n  color: #fff;\n}\n\n.aca-btn--ghost {\n  background: #fff;\n  color: var(--aca-ink);\n  border: 1px solid var(--aca-border);\n}\n\n.aca-typing {\n  align-self: flex-start;\n  display: inline-flex;\n  gap: 4px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid var(--aca-border);\n  border-radius: 14px;\n}\n\n.aca-typing span {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--aca-muted);\n  animation: aca-dot 1.1s infinite ease-in-out;\n}\n\n.aca-typing span:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.aca-typing span:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n@keyframes aca-dot {\n  0%,\n  80%,\n  100% {\n    opacity: 0.35;\n    transform: translateY(0);\n  }\n  40% {\n    opacity: 1;\n    transform: translateY(-3px);\n  }\n}\n\n.aca-footer {\n  border-top: 1px solid var(--aca-border);\n  background: #fff;\n  padding: 10px 12px calc(10px + env(safe-area-inset-bottom));\n  display: flex;\n  gap: 8px;\n  align-items: flex-end;\n}\n\n/* Border lives on the wrap so the textarea scrollbar cannot clip the right edge */\n.aca-input-wrap {\n  flex: 1;\n  min-width: 0;\n  border: 1.5px solid var(--aca-border);\n  border-radius: 12px;\n  background: var(--aca-soft);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.aca-input-wrap:focus-within {\n  border-color: var(--aca-blue);\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(45, 99, 235, 0.15);\n}\n\n.aca-root .aca-input {\n  display: block;\n  width: 100%;\n  min-height: 42px;\n  max-height: 110px;\n  resize: none;\n  border: none !important;\n  padding: 10px 12px;\n  font-size: 14px;\n  line-height: 1.35;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent;\n  color: var(--aca-ink);\n}\n\n.aca-root .aca-input:focus {\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent;\n}\n\n.aca-root .aca-send {\n  width: 42px;\n  height: 42px;\n  border: none;\n  border-radius: 12px;\n  background: var(--aca-orange);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s ease, transform 0.15s ease;\n}\n\n.aca-root .aca-send .aca-send-icon {\n  width: 26px !important;\n  height: 26px !important;\n  color: #fff;\n  stroke: #fff;\n}\n\n.aca-root .aca-send:hover:not(:disabled),\n.aca-root .aca-send:focus-visible:not(:disabled) {\n  background: #ffb347;\n  color: #fff;\n  outline: none;\n  transform: translateY(-1px);\n}\n\n.aca-root .aca-send:active:not(:disabled) {\n  background: #e67e00;\n  transform: translateY(0);\n}\n\n.aca-root .aca-send:disabled {\n  background: #f7c78a;\n  color: #fff;\n  opacity: 1;\n  cursor: not-allowed;\n}\n\n.aca-root .aca-send:disabled .aca-send-icon {\n  opacity: 0.85;\n}\n\n.aca-state-pill {\n  align-self: center;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: capitalize;\n  color: var(--aca-blue);\n  background: rgba(255, 255, 255, 0.95);\n  border: 1px solid #d7e0f5;\n  border-radius: 999px;\n  padding: 4px 12px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n\n@media (max-width: 768px) {\n  .aca-root {\n    right: 12px;\n    bottom: 12px;\n  }\n\n  .aca-panel {\n    width: calc(100vw - 24px);\n    height: min(78dvh, 620px);\n    border-radius: 16px;\n  }\n\n  .aca-fab {\n    width: 56px;\n    height: 56px;\n  }\n}\n\n@media (max-width: 480px) {\n  .aca-panel {\n    position: fixed;\n    inset: auto 0 0 0;\n    width: 100vw;\n    height: min(88dvh, 100dvh);\n    max-height: 100dvh;\n    border-radius: 18px 18px 0 0;\n    right: 0;\n    bottom: 0;\n  }\n\n  .aca-root {\n    right: 12px;\n    bottom: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
